<template>
  <input-widget :model="model" :attribute="attribute" :label="label" :options="options" type="select2"
                :display-field="displayField" :value-field="valueField" :hint="hint" :items="computedCurrencies"
                :rules="rules" @select2Select="onSelect" :disabled="disabled"/>
</template>


<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";

  const {mapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "CurrencySelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      rules: {
        type: String,
        default: null,
        required: false
      },
      options: {
        type: Object,
        default: () => {
          return {};
        }
      },
      displayField: {
        type: String,
        default: '${item.code} (${item.symbol})'
      },
      valueField: {
        type: String,
        default: 'uuid'
      },
      items: {
        type: [Object, Array],
        default: () => {
          return null
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      ...mapState(['currencies']),
      computedCurrencies() {
        return this.items ? this.items : this.currencies
      }
    },
    methods: {
      onSelect(data) {
        this.$emit('select', data);
      },
    },
  }
</script>

<style scoped>

</style>
